import { Shipper } from "../interfaces";
import fetchCreator from "../utils/fetchCreator";

const client = new fetchCreator();

export const createOffers = ({
  request_id,
  shippers,
}: {
  request_id: string;
  shippers: any[];
}) => {
  const shippersObject = shippers.reduce(
    (acc: any, shipper: Shipper) => ({
      ...acc,
      [shipper.id || 0]: shipper,
    }),
    {}
  );

  client
    .post("offers", { request_id, shippers: shippersObject })
    .then((data: any) => data.data);
};
